import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex align-center primary--text justify-space-between" }
const _hoisted_2 = {
  key: 0,
  class: "tag mr-2",
  style: {"opacity":"0.6"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_profile = _resolveComponent("profile")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex align-center justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                label: "Recherche",
                outlined: "",
                "hide-details": "",
                density: "compact",
                clearable: "",
                "append-inner-icon": "$search"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto')
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtreSearch(), (item) => {
          return (_openBlock(), _createBlock(_component_v_row, {
            "no-gutters": "",
            class: "d-flex justify-center mt-4",
            key: item.name
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "8" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "default_card mt-0 mb-4 mx-0",
                    outlined: "",
                    style: {"cursor":"pointer"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          (!_ctx.$vuetify.display.mobile)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "2",
                                class: "d-flex align-center pa-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_avatar, { color: "secondary" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                                          _createTextVNode("$label")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : ''),
                                  style: {"font-weight":"bold","font-size":"16pt"}
                                }, _toDisplayString(item.displayName
                                                ? item.displayName
                                                : item.name
                                                  ? _ctx.$t(`profiles.name.${item.name}`)
                                                  : "Profil sans nom"), 3),
                                (item.profile)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.getProfileName(item)), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, { cols: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "6",
                                    class: "d-flex justify-center pa-0"
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.userHasPermissions(item))
                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                            key: 0,
                                            location: "bottom"
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              (_ctx.userHasPermissions(item))
                                                ? (_openBlock(), _createBlock(_component_v_btn_icon, _mergeProps({
                                                    key: 0,
                                                    ref_for: true
                                                  }, props, {
                                                    icon: "$edit",
                                                    large: "",
                                                    color: "secondary",
                                                    onClick: ($event: any) => (_ctx.openProfile(item.id)),
                                                    class: "mt-1"
                                                  }), null, 16, ["onClick"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            default: _withCtx(() => [
                                              _cache[7] || (_cache[7] = _createElementVNode("span", null, "Modifier", -1))
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : (_openBlock(), _createBlock(_component_v_tooltip, {
                                            key: 1,
                                            location: "bottom"
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$oss-eye",
                                                large: "",
                                                color: "secondary",
                                                onClick: ($event: any) => (
                                                        _ctx.onClickProfileRulesDialog(item.id, item)
                                                    ),
                                                class: "mt-1"
                                              }, null, 8, ["onClick"])
                                            ]),
                                            default: _withCtx(() => [
                                              _cache[8] || (_cache[8] = _createElementVNode("span", null, "Voir", -1))
                                            ]),
                                            _: 2
                                          }, 1024)),
                                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_btn_icon, _mergeProps({ ref_for: true }, props, {
                                            icon: "$fa-clone",
                                            large: "",
                                            color: "secondary",
                                            onClick: ($event: any) => (_ctx.openDuplicateDialog(item)),
                                            disabled: _ctx.getRightToDuplicate(item) == false,
                                            class: "mt-1"
                                          }), null, 16, ["onClick", "disabled"])
                                        ]),
                                        default: _withCtx(() => [
                                          _cache[9] || (_cache[9] = _createElementVNode("span", null, "Dupliquer", -1))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "6",
                                    class: "d-flex justify-center pa-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_btn_trash, _mergeProps({ ref_for: true }, props, {
                                            onClick: ($event: any) => (_ctx.openDeleteDialog(item.id)),
                                            disabled: !_ctx.userHasPermissions(item),
                                            size: "large"
                                          }), null, 16, ["onClick", "disabled"])
                                        ]),
                                        default: _withCtx(() => [
                                          _cache[10] || (_cache[10] = _createElementVNode("span", null, "Supprimer", -1))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ], 4),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.duplicateDialog,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.duplicateDialog) = $event)),
        title: "Dupliquer ce profil ?",
        onValid: _cache[2] || (_cache[2] = ($event: any) => (_ctx.duplicateProfile())),
        previousDisplay: false,
        width: "60vw"
      }, {
        content: _withCtx(() => _cache[11] || (_cache[11] = [
          _createTextVNode(" Êtes-vous sur de vouloir dupliquer ce profil ? ")
        ])),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.deleteDialog,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.deleteDialog) = $event)),
        title: "Supprimer ce profil ?",
        onValid: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteProfile())),
        previousDisplay: false,
        width: "60vw"
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createTextVNode(" Êtes-vous sur de vouloir supprimer ce profil ? ")
        ])),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        title: 'Droits du profil - ' + _ctx.profileName,
        modelValue: _ctx.showProfileRulesDialog,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showProfileRulesDialog) = $event)),
        "min-width": "80vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_profile, {
            profileId: _ctx.shownProfileId,
            isConsultation: true
          }, null, 8, ["profileId"])
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ]),
    _: 1
  }))
}